import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/main.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));
